import { WizBasePopUp, WizButton, WizCommandManager, WizEvent, WizLabel, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { Model } from 'src/app/model/model';
@Component({
  selector: 'user-popup',
  templateUrl: './user.pop.html',
})
export class UserPopUp extends WizBasePopUp {
  @ViewChild('btnclearCache', { read: WizButton }) btnclearCache: WizButton; // reset du cache local
  @ViewChild('btnRefresh', { read: WizButton }) btnRefresh: WizButton; // reset du cache local
  @ViewChild('btnClearContext', { read: WizButton }) btnClearContext: WizButton; // reset du contexte utilisateur (local)
  @ViewChild('lblUser') lblUser: WizLabel;
  // @ViewChild('btnKillWorker', { read: WizButton }) btnKillWorker: WizButton; // reset du contexte utilisateur (local)
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  constructor(public elementRef: ElementRef) {
    super();
  }

  public show(): void {
    this.setUser();
  }

  public doAction(e: WizEvent): void {

    switch (e.component) {
      case this.btnclearCache:
        
        WizCommandManager.setLock(true);
        setTimeout(() => {
          Model.getInstance().syncService.clearFD();
          Model.getInstance().syncService.clearFEI();
          Model.getInstance().syncService.clearWorkcom();
          Model.getInstance().syncService.clearMedia();
          Model.getInstance().compositeEngine.compositeReload();
          this.hide();
        }, (0));

        break;
      case this.btnRefresh:  
        WizCommandManager.setLock(true);
        setTimeout(() => {
          Model.getInstance().compositeEngine.compositeReload(); 
          this.hide();
        }, (0));

        break;
      case this.btnClearContext:  
        Model.getInstance().userContextService.resetLocalStorage();
        this.hide();
        break;
    }
  }

  /** sur alimentation du user, affichage de message de bienvenue */
  private setUser(): void {
    if (Model.getInstance().connectedUser) {
      this.lblUser.wizLabel = WizTranslationManager.getInstance().translateKey('$.account.hello.$', [
        Model.getInstance().connectedUser.fullName,
      ]);
    } else {
      this.lblUser.wizLabel = ' ';
    }
  }


}
